import Q from 'q';

import membershipsPromise from 'bundles/catalogP/promises/memberships';

const membershipFields = {
  showHidden: true,

  fields: ['courseId', 'grade'],

  includes: {
    vcMembership: {
      fields: ['certificateCode', 'grade', 'grantedAt'],
    },
    course: {
      fields: [],
    },
  },
};

/**
 * @param {Fluxible.ActionContext} actionContext
 * @param {object} options
 * @param {string} options.courseId
 * @param {string} options.userId
 * @return {Promise}
 */

export const loadCertificateData = function (actionContext: $TSFixMe, { courseId, userId }: $TSFixMe) {
  if (actionContext.getStore('CertificateStore').hasLoaded()) {
    return Q();
  }

  let promise;

  if (userId) {
    promise = membershipsPromise({
      id: `${userId}~${courseId}`,
      ...membershipFields,
      rawData: true,
    }).then((memberships) => {
      actionContext.dispatch('LOAD_MEMBERSHIPS', memberships);
    });
  } else {
    promise = Q().then(() => {
      actionContext.dispatch('LOAD_MEMBERSHIPS', null);
    });
  }

  promise.done();
  return promise;
};
